<template>
    <router-view appear :key="path"></router-view>
</template>


<script>
export default {
  name: "WebsiteModule",
  components: {},
  data: () => ({
    path: null
  }),
};
</script>
